module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigationBar"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.$store.state.spinning) ? _c('img', {
    staticClass: "kyushinjuku-logo",
    attrs: {
      "src": require("../../../assets/img/logo.png")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$store.state.spinning) ? _c('spinner', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "color": 'white',
      "size": '40px'
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.left",
      value: (_vm.swipeHandler),
      expression: "swipeHandler",
      arg: "swipe",
      modifiers: {
        "left": true
      }
    }]
  }, [_c('label', {
    on: {
      "click": _vm.open_Menu
    }
  }, [_c('span', [(!_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-menu menu_style"
  }) : _vm._e(), (_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-exclamation-sign attention"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-drawer"
    }
  }, [_c('input', {
    staticClass: "nav-unshown",
    attrs: {
      "id": "nav-input",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "nav-unshown",
    attrs: {
      "id": "nav-close",
      "for": "nav-input"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-content"
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('h1', {
    staticClass: "mune_title"
  }, [_vm._v("Menu\n              "), (_vm.$store.state.userInfo.user_type !== 'student') ? _c('span', {
    staticClass: "school",
    on: {
      "click": [_vm.schoolChange, _vm.close_Menu]
    }
  }, [(_vm.$store.state.userInfo.school_id === '1') ? _c('a', {
    staticClass: "school_ike"
  }, [_vm._v("池袋校")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.school_id === '2') ? _c('a', {
    staticClass: "school_yoko"
  }, [_vm._v("横浜校")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('datepicker', {
    style: ('float:right;'),
    attrs: {
      "language": "ja",
      "format": 'yyyy年MM月dd日(D)',
      "value": _vm.$store.state.curDate.toISOString(),
      "inline": true,
      "disabled": _vm.getDisableDays()
    },
    on: {
      "selected": _vm.dateSelectHandler,
      "input": _vm.close_Menu
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpTable",
      "title": "座席予約表を見る"
    }
  }, [_c('i', {
    staticClass: "icon-timeline"
  }), _vm._v(" "), _c('span', [_vm._v("座席予約表を見る")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpRescheduling",
      "title": "予約変更"
    }
  }, [_c('i', {
    staticClass: "icon-alarm"
  }), _vm._v(" "), _c('span', [_vm._v("振替を依頼する")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpReschedulingList",
      "title": "依頼リスト"
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v(" "), _c('span', [_vm._v("依頼リスト")]), _vm._v(" "), (_vm.reschedulinglist) ? _c('i', {
    staticClass: "icon-exclamation-sign",
    staticStyle: {
      "color": "red",
      "font-size": "8vh"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpHelpPage",
      "title": "ヘルプ"
    }
  }, [_c('i', {
    staticClass: "icon-question-sign"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ヘルプ")])])], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close_Menu
    }
  }, [_c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/Spuser",
      "title": "ユーザー情報"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', [_vm._v("ユーザー情報")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "menubutton",
    attrs: {
      "title": "ログアウト"
    },
    on: {
      "click": _vm.beforeLogout
    }
  }, [_c('i', {
    staticClass: "icon-exit"
  }), _vm._v(" "), _c('span', {
    staticClass: "explanationText"
  }, [_vm._v("ログアウト")])]), _vm._v(" "), _c('span', {
    staticClass: "onlineCheckBox",
    attrs: {
      "id": "onlineCheckBox"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "showOnline",
      "name": "showOnline"
    },
    on: {
      "click": _vm.showOnline
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showOnline"
    }
  }, [_vm._v("オンライン授業表示")])])], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottomline"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e06c833c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/header/SpAppHeader.vue
// module id = 744
// module chunks = 0